 
import React , {useRef , useState , useContext } from "react";
import { FileUpload } from 'primereact/fileupload'; 
import { useDispatch } from 'react-redux';
import profilesTemplate from "../../../assets/respondent_import_template.xlsx";
import {ClientService} from '../services/ClientService';
import AppContext from '../components/AppContext';
import { onChangeLoading } from "../../redux/actions/ActionApp";
import { ErrorParse } from '../../shared/handlers/ErrorParse';

import "./../../../styles/ImportFromFile.scss";
import { useTranslation } from 'react-i18next';

/**
 * It returns a div with a className of "ImportFromFile active" which contains a div with a className
 * of "ImportFromFile-container" which contains a div with a className of "image" which contains an h2
 * and a div with a className of "closeWindow" which contains nothing, and a div with a className of
 * "context" which contains a div with a className of "active" which contains an h4, a p, and a
 * FileUpload component, and a div with a className of "" which contains an h4, an h4 with a className
 * of "green", and a div with a className of "absolute" which contains a Button component with a label
 * of "Import More" and a className of "p-button-success p-button-outlined", and a Button component
 * with a label of "Done" and a className of "p-button-success", and a div with
 * @returns A React component.
 */
export default function ImportFromFile({ showImportClient  }) {
    const { t } = useTranslation();
    const fileUploadRef = useRef(null);  
    const [isComplete, setIsComplete] = useState(false); 
    const clientService = ClientService(); 
    const myContext = useContext(AppContext); 
    const dispatch = useDispatch(); 

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column"  
             >
                <i className="pi pi-image mt-3 p-5" style={{'fontSize': '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)'}}></i>
                <span style={{'fontSize': '1.2em', color: 'var(--text-color-secondary)'}} className="my-5">{t('IMPORT_FROM_FILE.DRAG_AND_DROP')}</span>
            </div>
        )
    } 

    const onUploadFile = async (event) => {
        // convert file to base64 encoded
        const file = event.files[0];
        dispatch(onChangeLoading());
        clientService.ImportProfiles(myContext.user.SubjectId  , file).then(() => {  
            setIsComplete(true);
          }).catch(err => {
            myContext.notify6('alert' , 'Error' , ErrorParse(err) ); 
          }).finally(() => dispatch(onChangeLoading()) );  
    }
 
    const onSelect =(event) => {
        // convert file to base64 encoded  
        if (fileUploadRef.current.files.length > 1) {
            fileUploadRef.current.files.splice(fileUploadRef.current.files.length + 1 , 1);  
        }  
    }

    const chooseOptions = {label: t('IMPORT_FROM_FILE.BUTTONS.CHOOSE')};
    const uploadOptions = {label: t('IMPORT_FROM_FILE.BUTTONS.UPLOAD')};
    const cancelOptions = {label: t('IMPORT_FROM_FILE.BUTTONS.CANCEL')};
 
    return ( 
        <div className="ImportFromFile active">{/** toogle className="active" */}
            <div className="ImportFromFile-container">
                <div className="image">
                    <h2>{t('IMPORT_FROM_FILE.TITLE')}</h2>
                    <div className="closeWindow" onClick={() => showImportClient(false) } ></div>{/*on click remove active from ImportFromFile*/}
                </div>
                <div className="context">
                    {
                        !isComplete ?
                        <>
                            <div className="card active"> {/** toogle className="active" by phase */}   

                            <FileUpload
                                ref={fileUploadRef}
                                name="File"
                                multiple
                                accept=".xlsx"
                                maxFileSize={1000000}
                                chooseOptions={chooseOptions}
                                uploadOptions={uploadOptions}
                                cancelOptions={cancelOptions}
                                customUpload 
                                onSelect={onSelect}
                                uploadHandler={onUploadFile}  
                                emptyTemplate={emptyTemplate}   />

                            </div> 
                        </>
                        :
                        <>
                            <div className="card active"> 
                                <br></br>
                                <p class="text-center text-4xl w-10 text-green-500">
                                    {t('IMPORT_FROM_FILE.UPLOADED_SERVER')}
                                <br></br>
                                <br></br>
                                    {t('IMPORT_FROM_FILE.VERIFY_EMAIL')}</p>
                            </div>
                        </>
                    }

                    <div className="container-info-template">
                        <ul>
                            <span className="howTo">{t('IMPORT_FROM_FILE.CONTAINER_INFO_TEMPLATE.TITLE')}:</span>


                            <li>
                                {t('IMPORT_FROM_FILE.CONTAINER_INFO_TEMPLATE.ITEMS.ITEM_1')}
                                <a href={profilesTemplate} rel="noopener noreferrer" download={"respondent_import_template.xlsx"}>{t('IMPORT_FROM_FILE.CONTAINER_INFO_TEMPLATE.ITEMS.ITEM_1_REF')}.</a>
                            </li>
                            <li>
                                {t('IMPORT_FROM_FILE.CONTAINER_INFO_TEMPLATE.ITEMS.ITEM_2')}
                                <br/>
                                <strong>{t('IMPORT_FROM_FILE.CONTAINER_INFO_TEMPLATE.ITEMS.ITEM_2_NOTE')}</strong>
                            </li>
                            <li>{t('IMPORT_FROM_FILE.CONTAINER_INFO_TEMPLATE.ITEMS.ITEM_3')}</li>
                            <li>{t('IMPORT_FROM_FILE.CONTAINER_INFO_TEMPLATE.ITEMS.ITEM_4')}</li>
                        </ul>
                        <p>{t('IMPORT_FROM_FILE.CONTAINER_INFO_TEMPLATE.NOTE')}</p><br/>
                        <p>{t('IMPORT_FROM_FILE.CONTAINER_INFO_TEMPLATE.NOTE_B')} <a href="mailto:info@refelectiveresearchgroup.com">info@refelectiveresearchgroup.com</a>.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
